import useCurrent from "lib/use-current"

export const useUser = () => {
  const current = useCurrent()

  // @ts-ignore
  return current?.user
}
